module.exports = __webpack_public_path__ + "static/media/tsb4kz.d1b1b75c.pdf";